export const doAbortFetchIfPossible = abortController => {
  if (abortController) {
    abortController.abort();
  }
};
